import React, { FC, KeyboardEvent } from 'react'
import { useFormikContext } from 'formik'
import { TextArea, TextAreaProps } from '@shared/ui/atoms'
import { suggestionFormFields } from '../config/suggestionFormFields'
import { SuggestionFormValues } from '../model/suggest.types'

type SuggesetionFieldProps = TextAreaProps

const SuggesetionField: FC<SuggesetionFieldProps> = (props) => {
  const { values, touched, errors, setFieldValue, setFieldTouched } = useFormikContext<SuggestionFormValues>()

  const meta = {
    touched: touched[suggestionFormFields.suggestion] as boolean,
    error: errors[suggestionFormFields.suggestion] as string,
  }

  const error = meta.touched && meta.error ? meta.error : ''

  const handleFieldChange = (value: string) => setFieldValue(suggestionFormFields.suggestion, value, true)

  const handleFieldBlur = () => setFieldTouched(suggestionFormFields.suggestion, true, true)

  const handleKeyDown = (event: KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault()
    }
  }

  return (
    <TextArea
      {...props}
      value={values.suggestion}
      onChange={handleFieldChange}
      onBlur={handleFieldBlur}
      onKeyDown={handleKeyDown}
      error={error}
    />
  )
}

export default SuggesetionField
